import { render, staticRenderFns } from "./ztsc_xqy.vue?vue&type=template&id=208e8eef&scoped=true&"
import script from "./ztsc_xqy.vue?vue&type=script&lang=js&"
export * from "./ztsc_xqy.vue?vue&type=script&lang=js&"
import style0 from "./ztsc_xqy.vue?vue&type=style&index=0&id=208e8eef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e8eef",
  null
  
)

export default component.exports